import SilentRenew from './SilentRenew';

const SilentRenewConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  routes: [
    {
      path: 'silent-renew',
      element: <SilentRenew />,
    },
  ],
};

export default SilentRenewConfig;
